import { render, staticRenderFns } from "./ResolutionLogs.vue?vue&type=template&id=8475d6d2&scoped=true&"
import script from "./ResolutionLogs.vue?vue&type=script&lang=js&"
export * from "./ResolutionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8475d6d2",
  null
  
)

export default component.exports